const _excluded = ["children", "href", "data-qa", "className", "underline"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { Link as Link$1 } from '@cbhq/cds-web/typography/Link';
import { useAnalyticsContext } from '../../providers/AnalyticsProvider.js';
import { useLinkComponent } from '../../providers/LinkComponentProvider.js';
import { useLocaleContext } from '../../providers/LocaleProvider.js';
import { cleanUrlDuplicateSlashes } from '../../utils/cleanUrlDuplicateSlashes.js';
import { getIsAnchorLink } from '../../utils/getIsAnchorLink.js';
import { getIsRelativeUrl } from '../../utils/getIsRelativeUrl.js';
import { getLocalizedUrl } from '../../utils/getLocalizedUrl.js';
import { scrollToAnchor } from '../../utils/scrollToAnchor.js';
import { useIsExternalUrl } from './useIsExternalUrl.js';
import { jsx } from 'react/jsx-runtime';
function Link(_ref) {
  let children = _ref.children,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    _ref$dataQa = _ref['data-qa'],
    dataQa = _ref$dataQa === void 0 ? '' : _ref$dataQa,
    className = _ref.className,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? false : _ref$underline,
    props = _objectWithoutProperties(_ref, _excluded);
  const cleanHref = cleanUrlDuplicateSlashes(href);
  const isCtaPhone = href.startsWith('tel');
  const isMailtoCta = href.startsWith('mailto');
  const isRelativeUrl = getIsRelativeUrl(cleanHref);
  const isAnchorLink = getIsAnchorLink(cleanHref);
  const isExternalUrl = useIsExternalUrl(cleanHref);
  const _useLocaleContext = useLocaleContext(),
    locale = _useLocaleContext.locale;
  const LinkComponent = useLinkComponent();
  const _useAnalyticsContext = useAnalyticsContext(),
    analyticsPrefix = _useAnalyticsContext.analyticsPrefix;
  const localizedUrl = isRelativeUrl ? cleanHref : getLocalizedUrl(cleanHref, locale);
  const finalDataQa = `${analyticsPrefix}${dataQa && analyticsPrefix ? '-' : ''}${dataQa}`;

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
  const onAnchorLinkPress = event => {
    event.preventDefault();
    scrollToAnchor(cleanHref.replace('#', ''));
  };
  if (!!LinkComponent && isRelativeUrl && !isCtaPhone && !isMailtoCta) {
    return (/*#__PURE__*/
      // eslint-disable-next-line @cbhq/react-no-nested-component -- TODO Fix this
      jsx(LinkComponent, {
        href: cleanHref,
        "data-qa": finalDataQa,
        children: /*#__PURE__*/jsx(Link$1, _objectSpread(_objectSpread({}, props), {}, {
          underline: underline,
          className: className,
          "data-qa": finalDataQa,
          children: children
        }))
      })
    );
  }
  return /*#__PURE__*/jsx(Link$1, _objectSpread(_objectSpread({}, props), {}, {
    underline: underline,
    href: isCtaPhone || isMailtoCta ? href : localizedUrl,
    "data-qa": finalDataQa,
    openInNewWindow: isExternalUrl,
    className: className,
    rel: isExternalUrl ? 'noopener noreferrer' : undefined,
    onPress: isAnchorLink ? onAnchorLinkPress : undefined,
    children: children
  }));
}
export { Link };
//# sourceMappingURL=Link.js.map
